const MAX_VISIBLE_ITEMS = 3;

export { MAX_VISIBLE_ITEMS };
